import React, { useEffect, useState } from "react";
import { getAllObjects } from "../firebase/playerFuncs";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useHandleOpenObject from "../hooks/useHandleOpenObject";
import useHandlePlayerArrays from "../hooks/useHandlePlayerArrays";
import useSizePercentage from "../hooks/useSizePercentage";
import { saveGoal } from "../misc/objects/objectFuncs";
import boxStore from "../stores/boxStore";
import collectionStore from "../stores/collectionStore";
import MainStore from "../stores/MainStore";
import GeneralBox from "./GeneralBox";
import SideBar from "./SideBar";

export const Box = ({ type, object, from }) => {
  const { displayedBoxes, setDetailedView, player } = MainStore();
  const { addGeneralObjects } = collectionStore();
  const { addObject, getObject } = useHandlePlayerArrays();
  const [preferedImage, setPreferedImage] = useState(null);
  const [objects, setObjects] = useState(null);
  const [sideBarCounter, setSideBarCounter] = useState({ open: [], saved: [] });
  const { getPluralType, getBoxType } = useHandleBoxTypes();

  const sizePercentage = useSizePercentage();

  const handleOpenObject = useHandleOpenObject({
    onOpened,
    objects,
    onBack: () => {},
  });

  function onOpened(open) {
    setObjects({ ...objects, open: open });
  }

  function openGoal() {
    const boxType = getBoxType(type);
    if (!objects.saved) {
      saveGoal(
        getPluralType,
        boxType,
        objects.general,
        player.uid,
        (savedObject) => {
          setObjects({ ...objects, saved: savedObject });
          addObject("saved", savedObject);
          handleOpenObject.open();
        }
      );
    } else {
      handleOpenObject.open();
    }
  }

  function getMostLikedImage(images) {
    const sorted = images.sort((a, b) => (a.upvoted > b.upvoted ? 1 : -1));
    return sorted[0].image;
  }

  function onBoxClicked() {
    setDetailedView(objects);
  }

  // image counter counterdescription
  function getSideBarCounter() {
    const counter = { open: [], saved: [] };

    if (objects.open) {
      counter.open = [
        {
          counter: objects.open.points.own + objects.open.points.others,
          image: "/icons/icon_point.png",
          counterDescription: null,
        },
        {
          counter: objects.open.reports.length,
          image: "/icons/icon_report.png",
          counterDescription: null,
        },
        {
          counter: objects.open.focuses.length,
          image: "/icons/icon_focus.png",
          counterDescription: null,
        },
        {
          counter: objects.open.thoughts.length,
          image: "/icons/icon_thought.png",
          counterDescription: null,
        },
        {
          counter: objects.open.minutes.open,
          image: "/icons/icon_time.png",
          counterDescription: null,
        },
      ];
    }
    if (objects.saved) {
      counter.saved = [
        {
          counter: objects.saved.opened,
          image: "/icons/icon_open.png",
          counterDescription: null,
        },
        {
          counter: objects.saved.putInActive,
          image: "/icons/icon_active.png",
          counterDescription: null,
        },
        {
          counter: objects.saved.completed,
          image: "/icons/icon_checkmark.png",
          counterDescription: null,
        },
      ];
    }
    setSideBarCounter(counter);
  }

  useEffect(() => {
    if (objects) {
      getSideBarCounter();
      if (objects.open) {
        if (objects.open.image) {
          setPreferedImage(objects.open.image);
          return;
        }
      } else if (objects.general.image?.length > 0) {
        setPreferedImage(objects.general.image);
      }
    }
  }, [objects]);

  // player, type, object, id, onObjectsCollected
  useEffect(() => {
    getAllObjects(
      getObject,
      type,
      from == "general" ? object : null,
      from != "general" ? object.id : null,
      addGeneralObjects,
      getPluralType,
      (objects) => {
        setObjects(objects);
      }
    );
  }, []);

  function openObject() {}

  // when an object is not in open and/or not in saved
  function saveObject(place) {
    const boxType = getBoxType(type);
    saveGoal(getPluralType, objects.general, player.uid, (savedObject) => {
      setObjects({ ...objects, saved: savedObject });
      addObject("saved", savedObject);
      handleOpenObject.open();
    });
  }

  return (
    <div
      className="divRow"
      style={{
        cursor: "pointer",
        backgroundColor: getBoxType(object.type).colors.secondary,
        borderRadius: "1rem/1rem",
        border: "1px solid black",
        height:
          displayedBoxes.length < 4
            ? "260px"
            : `${(260 / 100) * sizePercentage.total}px`,
      }}
    >
      <SideBar
        general={objects}
        type={type}
        place={"Open"}
        onSidebarClicked={openGoal}
        counter={sideBarCounter.open}
        typeIcon={`/icons/icon_${type}.png`}
      />
      <div
        onClick={onBoxClicked}
        style={{
          minWidth: "140px",
          minHeight: "140px",
          width:
            displayedBoxes.length < 4
              ? "260px"
              : `${(260 / 100) * sizePercentage.total}px`,
          height:
            displayedBoxes.length < 4
              ? "260px"
              : `${(260 / 100) * sizePercentage.total}px`,
        }}
      >
        {
          <GeneralBox
            objects={objects}
            general={objects?.general}
            preferedImage={preferedImage}
          />
        }
      </div>
      <SideBar
        place={"Saved"}
        type={type}
        onSidebarClicked={saveObject}
        counter={sideBarCounter.saved}
        typeIcon={`/icons/icon_${type}.png`}
      />
      {handleOpenObject.modal}
    </div>
  );
};
